import React from "react";

import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Link as RouterLink } from 'react-router-dom';
import { config } from "../../config";

import ExternalLink from "../ExternalLink";
import WrapperComponent from "../WrapperComponent";
import enlight_logo from "../../assets/images/newLogos/Enlight-RGB.png";

const navbarStyles = {
  height: "6rem",
  backgroundColor: "#fff",
  padding: { xs: "1rem", md: "0.5rem 4rem" },
  boxShadow: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};

const Navbar: React.FC = () => {
  const isDevelopment = (process.env.REACT_APP_ENVIRONMENT ?? process.env.NODE_ENV) === "development" ||
    (process.env.REACT_APP_ENVIRONMENT ?? process.env.NODE_ENV) === "staging";

  function Logout() {
    fetch(`${config.baseUrl}/api/logout`, {
      method: 'POST', // This should be a GET or POST request depending on how your backend is set up
      credentials: 'include', // Make sure credentials (cookies) are sent if needed
    })
      .then((response) => {
        if (response.redirected) {
          // If the response is a redirect, follow the redirect URL
          window.location.href = response.url;
        }
        // console.log(response);
      })
      .catch((error) => {
        // console.error('Error during SAML authentication:', error);
      });
  }
  return (
    <AppBar
      position="sticky"
      sx={navbarStyles}
    >
      <WrapperComponent>
        <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", }}>
          <Button
            component={RouterLink}
            to="/"
          >
            <img
              width="134.59px"
              src={enlight_logo}
              alt="ENLIGHT logo"
            />
          </Button>
          <ExternalLink
            href="https://enlight-eu.org/index.php/students/courses"
          >
            <Button
              color="enlightTeal"
              endIcon={<OpenInNewIcon />}
              sx={{ fontSize: "1.2rem" }}
            >
              ENLIGHT Joint Courses
            </Button>
          </ExternalLink>
          {isDevelopment &&
            <>
              <Button
                onClick={() => { window.location.href = `${config.baseUrl}/api/login`; }}>
                Log in
              </Button>
              <Button
                onClick={Logout}>
                Log out
              </Button>
            </>}
        </Box>
      </WrapperComponent>
    </AppBar>
  );
};

export default Navbar;
